import { functions, httpsCallable } from '@/firebase';
import { Timestamp } from 'firebase/firestore';

const call = async (name, data) => {
  const callable = httpsCallable(functions, name);
  const response = await callable(data);
  return response.data;
};

export async function loadCalendarAudienceOptions(schoolId) {
  if (!schoolId) return { version: 1, phases: [] };
  return call('loadCalendarAudienceOptions', { schoolId });
}

export async function getParentCalendarEvents({ schoolId, startDate, endDate }) {
  if (!schoolId || !startDate || !endDate) return [];
  const result = await call('getParentCalendarEvents', {
    schoolId,
    startMillis: startDate.getTime(),
    endMillis: endDate.getTime(),
  });
  return (result.events || []).map((event) => ({
    ...event,
    startDate: hydrateCallableTimestamp(event.startDate),
    endDate: hydrateCallableTimestamp(event.endDate),
    createdAt: hydrateCallableTimestamp(event.createdAt),
    updatedAt: hydrateCallableTimestamp(event.updatedAt),
  }));
}

function hydrateCallableTimestamp(value) {
  if (!value || typeof value !== 'object' || typeof value.toDate === 'function') return value;
  const seconds = value._seconds ?? value.seconds;
  const nanoseconds = value._nanoseconds ?? value.nanoseconds ?? 0;
  return Number.isFinite(seconds) && Number.isFinite(nanoseconds)
    ? Timestamp.fromDate(new Date((seconds * 1000) + (nanoseconds / 1_000_000)))
    : value;
}

export async function loadCalendarPhaseAudienceReview({ schoolId, eventId }) {
  return call('reviewCalendarPhaseAudience', { operation: 'load', schoolId, eventId });
}

export async function previewCalendarPhaseAudienceReview(review) {
  return call('reviewCalendarPhaseAudience', {
    operation: 'preview',
    schoolId: review.schoolId,
    eventId: review.eventId,
    eventFingerprint: review.eventFingerprint,
    mappingRevision: review.mappingRevision,
  });
}

export async function commitCalendarPhaseAudienceReview(review) {
  return call('reviewCalendarPhaseAudience', {
    operation: 'commit',
    schoolId: review.schoolId,
    eventId: review.eventId,
    eventFingerprint: review.eventFingerprint,
    mappingRevision: review.mappingRevision,
    reviewFingerprint: review.reviewFingerprint,
    requestId: review.requestId,
  });
}
